// will be eventually replaced by ES8 -> export default from './filename';
// see: https://github.com/leebyron/ecmascript-export-default-from
import FieldSide from './fieldSide';
export default FieldSide;
